import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import Separator from '../../../core/layout/Separator';
import Async from '../../../core/layout/Async';

const SystemTranslationProgress = (props) => {
  const status = props.total < 1 ? 'exception' : props.percentage >= 100 ? 'success' : 'normal';
  const strokeColorProps = {};
  if (status === 'normal') {
    strokeColorProps['strokeColor'] = 'red';
  }

  return (
    <Async fetching={props.fetching}>
      <div
        style={{
          textAlign: 'center',
        }}
      >
        <button
          style={{
            color: '#424242',
            fontSize: 14,
            textDecoration: 'underline',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            height: '50px',
          }}
          onClick={props.onClick}
        >
          {props.title}
        </button>
        <Separator size="xs" />
        <Progress type="circle" percent={props.percentage} {...strokeColorProps} status={status} />
        {props.total > 0 && props.percentage < 100 && (
          <div style={{ textAlign: 'center' }}>
            <span style={{ color: 'red' }}>{props.total}</span>
          </div>
        )}
      </div>
    </Async>
  );
};

SystemTranslationProgress.propTypes = {
  title: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  fetching: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

SystemTranslationProgress.defaultProps = {
  fetching: false,
};

export default SystemTranslationProgress;
